// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioDetail-module__container--uTO__{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%}.AudioDetail-module__container--uTO__ .audio-player{height:150px}.AudioDetail-module__container--uTO__ .audio-player-buttons{position:absolute;width:30px;bottom:30px;left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioDetail-module__container--uTO__`
};
module.exports = ___CSS_LOADER_EXPORT___;
